/**
 * @file  routes/index.ts
 * @description  renew router component
 *
 * @author ogarcia (ozkary)
 *
 */
import React, { memo, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { getPageRoutes, routeInfo } from '../../routes/pageLoader';
import routes, { baseRoutes } from './config';

/**
 * router management component to manage the application level routes
 *
 */
const Router = (): JSX.Element => {  
  const [pageRoutes, setPageRoutes] = useState([] as routeInfo[]);

  // initialize the route dependencies
  useEffect(() => {
    if (!pageRoutes || pageRoutes?.length < 1) {
      const list = getPageRoutes(routes, baseRoutes);
      setPageRoutes(list);      
    }    
  },[pageRoutes]);

  if (!pageRoutes || pageRoutes.length < 1) {
    return (<></>);
  }

  return (
    <Routes>
      {pageRoutes.map((routeItem) => (
        <Route
          key={routeItem.key}
          path={routeItem.path}
          element={
              <routeItem.elm />
          }
        />
      ))}
    </Routes>
  );
};

/**
 * Get the routes for the Renew edition
 * @param routes the route configuration
 * @returns the route information for this editions
 */
const getRenewRoutes = () : routeInfo[] => {
  return getPageRoutes(routes, baseRoutes);
};

export default memo(Router);
export {
  getRenewRoutes
}
